import { render, staticRenderFns } from "./SalesGroupsView.vue?vue&type=template&id=32d82297"
import script from "./SalesGroupsView.vue?vue&type=script&lang=js"
export * from "./SalesGroupsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports